import './assets/css/App.css';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { Provider } from 'react-redux';
import { configureAppStore } from 'store/configureStore';
import { Toaster } from 'sonner';

const root = ReactDOM.createRoot(document.getElementById('root'));
const store = configureAppStore();
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <Toaster richColors />
      <App />
    </Provider>
  </BrowserRouter>,
);
